import React from 'react';
import PageHero from '../components/site/PageHero';

export default function Legal({ title, eyebrow, body }) {
  return (
    <div>
      <PageHero eyebrow={eyebrow} title={title} image="https://ewenrealtors.com/assets/23_04_25/banners/web-banner1%20copy.webp" />
      <section className="bg-white py-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-10 prose prose-neutral">
          {body.map((p, i) => (
            <div key={i} className="mb-6">
              {p.heading && <h3 className="font-serif text-2xl text-[#0f1a14] mt-8 mb-3">{p.heading}</h3>}
              <p className="text-[#0f1a14]/75 leading-relaxed">{p.text}</p>
            </div>
          ))}
          <p className="text-xs uppercase tracking-widest text-[#8a6b3a] mt-12">Last updated: July 2025</p>
        </div>
      </section>
    </div>
  );
}

export const disclaimerBody = [
  { heading: 'General', text: 'The content on this website is for general information about Ewen Realtors and its projects. It should not be treated as an offer for sale or a contract.' },
  { heading: 'Project Specifications', text: 'All plans, images, layouts and specifications are indicative and may change based on regulatory approvals and design revisions.' },
  { heading: 'Investment', text: 'Prospective buyers are advised to independently verify all details, approvals and titles before making a purchase decision.' },
];

export const privacyBody = [
  { heading: 'Information We Collect', text: 'We collect information you provide to us via forms on this website, phone calls and site visits. This may include your name, email, phone and property preferences.' },
  { heading: 'How We Use It', text: 'Your information is used solely to respond to your enquiry, send you relevant project updates and comply with legal obligations. We never sell your data.' },
  { heading: 'Cookies', text: 'We use minimal cookies to improve your experience on this website. You may disable cookies via your browser settings.' },
];

export const termsBody = [
  { heading: 'Acceptance', text: 'By using this website you accept these Terms & Conditions. If you disagree with any part, please do not use the website.' },
  { heading: 'Content', text: 'All content, logos and marks on this website are the property of Ewen Realtors and may not be reproduced without permission.' },
  { heading: 'Bookings', text: 'Any booking or purchase is governed by the specific project agreement and applicable RERA regulations.' },
];

export const refundBody = [
  { heading: 'Booking Cancellations', text: 'Booking cancellations within the initial 15‑day window are eligible for a full refund of the booking amount, less applicable statutory deductions.' },
  { heading: 'Post 15 Days', text: 'Cancellations after the 15‑day window are subject to a deduction as per the sale agreement terms.' },
  { heading: 'Processing', text: 'Approved refunds are processed within 30 working days to the original mode of payment.' },
];
